export const NO_STORE_FOUND_ARTICLE = 'No stores found with article'
export const NO_STORE_FOUND_SIZE = 'No stores found with size'
export const SUCCESSFULL_SEARCH = 'Successful search'
export const STORE_INFO_PAGE = 'store_info_page_shown'
export const STORE_DISPLAY = 'STORE_DISPLAY'
export const STORE_MAP_PAGE_SHOWN = 'store_map_page_shown'
export const STORE_TOGGLE_ON_LABEL = 'stock toggle on'
export const STORE_TOGGLE_OFF_LABEL = 'stock toggle off'
export const CLOSED_FIND_IN_STORE = 'Close find in store'
export const ABANDON_NO_STORE_FOUND = 'Abandon no found stores'
export const ADD_TO_BAG_VERIFICATION_TIMESPAN = 3000

export const FAVOURITES_PREVIEW_MAX_ITEMS_IN_CAROUSEL = 7
export const FAVOURITES_PREVIEW_MAX_ITEMS_TO_SHOW_SMALL = 2
export const FAVOURITES_PREVIEW_MAX_ITEMS_TO_SHOW_MEDIUM = 3
export const FAVOURITES_PREVIEW_MAX_ITEMS_TO_SHOW_LARGE = 4

export const STYLEBOARDS_PREVIEW_MAX_ITEMS_TO_SHOW_SMALL = 2
export const STYLEBOARDS_PREVIEW_MAX_ITEMS_TO_SHOW_MEDIUM = 3
export const STYLEBOARDS_PREVIEW_MAX_ITEMS_TO_SHOW_LARGE = 2

export const FOLLOWING_PREVIEW_MAX_ITEMS_TO_SHOW_SMALL = 3
export const FOLLOWING_PREVIEW_MAX_ITEMS_TO_SHOW_MEDIUM = 4
export const FOLLOWING_PREVIEW_MAX_ITEMS_TO_SHOW_LARGE = 3
